import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemLine extends DrawingDataItem {
    constructor(subTypeValue: 'HORIZONTAL' | 'VERTICAL' | 'CUSTOM') {
        super();
        this.typeValue = 'line';
        this.properties = {
            origin: undefined,
            destination: undefined
        }
        this.subTypeValue = subTypeValue;
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.origin),
            DrawingDataItemPoint.fromVisiblePoint(this.properties.destination),
            DrawingDataItemPoint.fromNotVisiblePoint(this.properties.originalDestination)
        ];
    }

    public onMouseDown(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        if (this.properties.origin) {
            return {
                changed: false,
                stillDrawing: false
            };
        }

        this.properties.origin = {
            x: canvasRelativeX,
            y: canvasRelativeY,
        }
        return {
            changed: true,
            stillDrawing: true
        };
    }

    public onMouseMove(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.destination = {
            x: canvasRelativeX,
            y: canvasRelativeY
        }

        this.properties.originalDestination = {
            x: canvasRelativeX,
            y: canvasRelativeY
        }

        this.changeCoordinatesAccordingToSubTypeValue();
        return {
            stillDrawing: true,
            changed: true
        };
    }

    public draw(ctx: CanvasRenderingContext2D) {
        if (this.properties.destination) {
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.moveTo(this.properties.origin.x, this.properties.origin.y);
            ctx.lineTo(this.properties.destination.x, this.properties.destination.y);
            ctx.stroke();
        }
    }

    protected subTypeValueChanged() {
        this.changeCoordinatesAccordingToSubTypeValue()
    }

    private changeCoordinatesAccordingToSubTypeValue() {
        if (this.properties?.origin && this.properties.destination && this.properties.originalDestination) {
            if (this.subTypeValue === 'HORIZONTAL') {
                this.properties.destination.x = this.properties.originalDestination.x;
                this.properties.destination.y = this.properties.origin.y;
            } else if (this.subTypeValue === 'VERTICAL') {
                this.properties.destination.x = this.properties.origin.x;
                this.properties.destination.y = this.properties.originalDestination.y;
            } else {
                this.properties.destination.x = this.properties.originalDestination.x;
                this.properties.destination.y = this.properties.originalDestination.y;
            }
        }
    }
}